var map = {
	"./logo-bubble.svg": "75da",
	"./logo-dark.svg": "5a04",
	"./logo-gtr.svg": "6d24",
	"./logo-light.svg": "56c4",
	"./logo-megaphone.svg": "2740",
	"./logo-rossignol.svg": "9c9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e92";